import { useCallback } from "react";

import {
  statusDisplayConfigVar,
  currentProgressMessageIdVar,
  currentStatusVar,
  isLoadingVar,
  agentProgressVar,
} from "@/stores/knowledgeGraph";

/**
 * Custom hook for managing chat configuration and display operations
 * @remarks
 * Provides operations to reset chat configurations and hide status displays.
 * Uses Apollo reactive variables for state management.
 * @returns Chat configuration operation functions
 */
export const useChatConfigOperations = () => {
  /**
   * Reset chat configurations to default values
   */
  const resetChatConfigs = useCallback(() => {
    statusDisplayConfigVar({
      showProgress: true,
      showTimestamps: false,
      showDurations: true,
      compactMode: false,
    });
    currentProgressMessageIdVar(null);
  }, []);

  /**
   * Force hide status overlay by clearing status-related state
   * Used for manual completion detection
   */
  const hideStatusDisplay = useCallback(() => {
    currentStatusVar(null);
    isLoadingVar(false);
    agentProgressVar([]);
  }, []);

  return {
    resetChatConfigs,
    hideStatusDisplay,
  };
};
